/* 
 *
 * title.js 
 *
 */

import {
    createSlice
} from "@reduxjs/toolkit";
import titleAPI from "../../api/titleAPI";
import {
    fetchTitleProjects,
    createProject
} from "./project";
import {
    fetchGlossariesByTitle,
    assignGlossaryToTitle,
    unassignGlossaries,
    setGlossaryContractorWrite
} from "./glossary";
import {
    fetchMemoriesByTitle,
    assignMemoryToTitle,
    updateTitleMemoryPenalties,
    setTitleMemoryWrites,
    unassignMemoryFromTitle
} from "./memory";
import thunk from "../../helpers/thunk";

/* thunks */
const fetchTitles = thunk(
    "title/fetchTitles",
    titleAPI.fetchAll,
    o => o.r.data
);

const fetchTitle = thunk(
    "title/fetchTitle",
    titleAPI.fetchByID,
    o => o.r.data
);

const createTitle = thunk(
    "title/createTitle",
    titleAPI.create,
    o => o.r.data
);


const setTitleName = thunk(
    "title/setTitleName",
    titleAPI.setName,
    o => ({
        ...o.d
    })
);

const deleteTitle = thunk(
    "title/deleteTitle",
    titleAPI.delete,
    o => ({
        ...o.d
    })
);


/* slice */
const slice = createSlice({
    name: "title",
    initialState: {
        titles: {}
    },
    reducers: {

    },
    extraReducers: {
        [fetchTitles.fulfilled]: (state, action) => {
            action.payload.forEach(title => {
                state.titles[title.ID] = {
                    name: title.name,
                    projects: [],
                    glossaries: {},
                    memories: {}
                };
            });
        },
        [fetchTitle.fulfilled]: (state, action) => {
            state.titles[action.payload.ID] = {
                name: action.payload.name,
                projects: [],
                glossaries: {},
                memories: {}
            };
        },
        [fetchTitleProjects.fulfilled]: (state, action) => {
            state.titles[action.payload.titleID].projects = action.payload.projects.map(project => project.ID);
        },
        [fetchGlossariesByTitle.fulfilled]: (state, action) => {
            const glossaries = action.payload.data;
            const titleID = action.payload.titleID;

            glossaries.forEach(glossary => {
                state.titles[titleID].glossaries[glossary.ID] = {
                    contractorWrite: glossary.contractorWrite
                };
            });
        },
        [fetchMemoriesByTitle.fulfilled]: (state, action) => {
            const memories = action.payload.data;
            const titleID = action.payload.titleID;

            memories.forEach(memory => {
                state.titles[titleID].memories[memory.ID] = {
                    penalty: memory.penalty,
                    write: memory.write
                }
            });
        },
        [unassignGlossaries.fulfilled]: (state, action) => {
            const glossaryIDs = action.payload.glossaryIDs;
            const titleID = action.payload.titleID;
            if (titleID) {
                glossaryIDs.forEach(glossaryID => {
                    delete state.titles[titleID].glossaries[glossaryID];
                });
            }
        },
        [assignGlossaryToTitle.fulfilled]: (state, action) => {
            const glossary = action.payload.data;
            const titleID = action.payload.titleID;

            state.titles[titleID].glossaries[glossary.ID] = {
                contractorWrite: glossary.contractorWrite
            };
        },
        [assignMemoryToTitle.fulfilled]: (state, action) => {
            const memory = action.payload.data;
            const titleID = action.payload.titleID;

            state.titles[titleID].memories[memory.ID] = {
                penalty: memory.penalty,
                write: memory.write
            }
        },
        [createProject.fulfilled]: (state, action) => {
            const project = action.payload.project;
            const titleID = action.payload.titleID;

            state.titles[titleID].projects.push(project.ID);
        },
        [updateTitleMemoryPenalties.fulfilled]: (state, action) => {
            const memoryIDs = action.payload.memoryIDs;
            const penalty = action.payload.penalty;
            const titleID = action.payload.titleID;

            memoryIDs.forEach(ID => {
                state.titles[titleID].memories[ID].penalty = penalty;
            });
        },
        [setTitleMemoryWrites.fulfilled]: (state, action) => {
            const memoryIDs = action.payload.memoryIDs;
            const write = action.payload.write;
            const titleID = action.payload.titleID;

            memoryIDs.forEach(ID => {
                state.titles[titleID].memories[ID].write = write;
            });
        },
        [createTitle.fulfilled]: (state, action) => {
            const title = action.payload;
            state.titles[title.ID] = {
                name: title.name,
                glossaries: {},
                projects: [],
                memories: {}
            };
        },
        [unassignMemoryFromTitle.fulfilled]: (state, action) => {
            const titleID = action.payload.titleID;
            const memoryIDs = action.payload.memoryIDs;

            memoryIDs.forEach(memoryID => delete state.titles[titleID].memories[memoryID]);
        },
        [setGlossaryContractorWrite.fulfilled]: (state, action) => {
            const titleID = action.payload.titleID;
            const glossaryIDs = action.payload.glossaryIDs;
            const contractorWrite = action.payload.contractorWrite;

            if (titleID) {
                glossaryIDs.forEach(glossaryID => {
                    state.titles[titleID].glossaries[glossaryID].contractorWrite = contractorWrite;
                });
            }
        },
        [setTitleName.fulfilled] : (state, action) => {
            const titleID = action.payload.titleID;
            const titleName = action.payload.titleName;

            state.titles[titleID].name = titleName;
        },
        [deleteTitle.fulfilled] : (state, action) => {
            const titleID = action.payload.titleID;

            delete state.titles[titleID];
            
        }
    }
});

export {
    fetchTitles,
    fetchTitle,
    createTitle,
    setTitleName,
    deleteTitle
};
export const {} = slice.actions;
export default slice.reducer;